module.exports = __webpack_public_path__ + "static/Ohalo-c63a69bd4f5dc066d6c72a063c4d1d93.jpg";